export default "__VITE_ASSET__Bocsqufg__"